export * from './location.model';
export * from './location-popup.service';
export * from './location.service';
export * from './location-dialog.component';
export * from './location-delete-dialog.component';
export * from './location-detail.component';
export * from './location.component';
export * from './location.route';



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/location/index.ts